import { VCol } from 'vuetify/lib/components/VGrid';
import { VExpansionPanel } from 'vuetify/lib/components/VExpansionPanel';
import { VExpansionPanelContent } from 'vuetify/lib/components/VExpansionPanel';
import { VExpansionPanelHeader } from 'vuetify/lib/components/VExpansionPanel';
import { VExpansionPanels } from 'vuetify/lib/components/VExpansionPanel';
import { VForm } from 'vuetify/lib/components/VForm';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VTextarea } from 'vuetify/lib/components/VTextarea';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "devicetype-packetparser-tester"
  }, [_c(VForm, {
    ref: "parserTestForm",
    on: {
      "submit": function ($event) {
        $event.preventDefault();
        return _vm.testParser.apply(null, arguments);
      }
    },
    model: {
      value: _vm.parserTestFormIsValid,
      callback: function ($$v) {
        _vm.parserTestFormIsValid = $$v;
      },
      expression: "parserTestFormIsValid"
    }
  }, [_c(VExpansionPanels, {
    staticClass: "my-4 dt-card-text-01",
    attrs: {
      "value": 0,
      "flat": ""
    }
  }, [_c(VExpansionPanel, [_c(VExpansionPanelHeader, [_c('div', {
    staticClass: "text-bold"
  }, [_vm._v("\n            " + _vm._s(_vm.$i18n_t('NiotaClassic.DeviceTypes.form.parser.parserTestHeader')) + "\n          ")])]), _c(VExpansionPanelContent, [_c(VRow, [_c(VCol, {
    attrs: {
      "cols": "0",
      "md": "3",
      "lg": "2"
    }
  }), _c(VCol, [_vm._v(_vm._s(_vm.$i18n_t('NiotaClassic.DeviceTypes.form.parser.parserTestText')))])], 1), _c(VRow, {
    attrs: {
      "align": "center"
    }
  }, [_c(VCol, {
    attrs: {
      "cols": "6",
      "md": "3",
      "lg": "2"
    }
  }, [_vm._v("\n              " + _vm._s(_vm.$i18n_t('NiotaClassic.DeviceTypes.form.parser.parserPayloadType')) + "\n            ")]), _c(VCol, [_c(VSelect, {
    attrs: {
      "data-cy": "payload_type",
      "color": _vm.color,
      "outlined": _vm.inpOutlined,
      "filled": _vm.inpFilled,
      "rules": _vm.requiredRule,
      "items": ['HEX', 'JSON'],
      "disabled": _vm.readonly,
      "label": "Payload type",
      "hide-details": "auto",
      "required": ""
    },
    on: {
      "change": _vm.validateForm
    },
    model: {
      value: _vm.parserTestData.payloadType,
      callback: function ($$v) {
        _vm.$set(_vm.parserTestData, "payloadType", $$v);
      },
      expression: "parserTestData.payloadType"
    }
  })], 1)], 1), _c(VRow, {
    attrs: {
      "align": "center"
    }
  }, [_c(VCol, {
    attrs: {
      "cols": "6",
      "md": "3",
      "lg": "2"
    }
  }, [_vm._v("\n              " + _vm._s(_vm.$i18n_t('NiotaClassic.DeviceTypes.form.parser.parserTestExamplePayload')) + "\n            ")]), _c(VCol, [_vm.parserTestData.payloadType === 'HEX' ? _c(VTextField, {
    attrs: {
      "data-cy": "example_payload",
      "color": _vm.color,
      "outlined": _vm.inpOutlined,
      "filled": _vm.inpFilled,
      "rules": _vm.payloadHexRule,
      "hide-details": "auto",
      "disabled": _vm.readonly,
      "autocomplete": "off",
      "required": ""
    },
    model: {
      value: _vm.parserTestData.payload,
      callback: function ($$v) {
        _vm.$set(_vm.parserTestData, "payload", $$v);
      },
      expression: "parserTestData.payload"
    }
  }) : _c(VTextarea, {
    attrs: {
      "color": _vm.color,
      "outlined": _vm.inpOutlined,
      "filled": _vm.inpFilled,
      "rules": _vm.payloadHexRule,
      "hide-details": "auto",
      "disabled": _vm.readonly,
      "autocomplete": "off"
    },
    model: {
      value: _vm.parserTestData.payload,
      callback: function ($$v) {
        _vm.$set(_vm.parserTestData, "payload", $$v);
      },
      expression: "parserTestData.payload"
    }
  })], 1)], 1), _c(VRow, {
    attrs: {
      "align": "center"
    }
  }, [_c(VCol, {
    attrs: {
      "cols": "6",
      "md": "3",
      "lg": "2"
    }
  }, [_vm._v("Frame Port (LoRaWAN)")]), _c(VCol, {
    attrs: {
      "cols": "6",
      "lg": "7"
    }
  }, [_c(VTextField, {
    attrs: {
      "data-cy": "lora_framePort",
      "color": _vm.color,
      "outlined": _vm.inpOutlined,
      "filled": _vm.inpFilled,
      "rules": _vm.requiredRule,
      "type": "number",
      "disabled": _vm.readonly,
      "hide-details": "auto",
      "autocomplete": "off",
      "required": ""
    },
    model: {
      value: _vm.parserTestData.loraFramePort,
      callback: function ($$v) {
        _vm.$set(_vm.parserTestData, "loraFramePort", $$v);
      },
      expression: "parserTestData.loraFramePort"
    }
  })], 1), _c(VCol, {
    attrs: {
      "cols": "12",
      "md": "3",
      "align": "right"
    }
  }, [_c('core-button', {
    attrs: {
      "color": _vm.color,
      "prepend-icon": "fa-play-circle",
      "disabled": !_vm.parserTestFormIsValid || _vm.readonly,
      "type": "submit",
      "data-cy": "parse_btn",
      "loading": _vm.isParsing
    }
  }, [_vm._v("\n                " + _vm._s(_vm.$i18n_t('NiotaClassic.DeviceTypes.form.parser.parserTestButton')) + "\n              ")])], 1)], 1), _vm.parserTestData.response ? _c(VRow, [_c(VCol, {
    attrs: {
      "cols": "0",
      "md": "3",
      "lg": "2"
    }
  }, [_vm._v("\n              " + _vm._s(_vm.$i18n_t('NiotaClassic.DeviceTypes.form.parser.parserOutput')) + "\n            ")]), _c(VCol, [_c('core-n20-card', {
    staticClass: "dt-card-text-01 payload"
  }, [_c('json-viewer', {
    staticClass: "niotixJsonViewer",
    attrs: {
      "value": _vm.parserTestData.response,
      "expand-depth": 2,
      "copyable": "",
      "expanded": ""
    },
    scopedSlots: _vm._u([{
      key: "copy",
      fn: function () {
        return [_c('core-button', {
          staticStyle: {
            "right": "-20px"
          },
          attrs: {
            "color": _vm.color,
            "disabled": _vm.readonly,
            "prepend-icon": "fa-copy"
          },
          on: {
            "click": _vm.copySuccess
          }
        })];
      },
      proxy: true
    }], null, false, 4046851975)
  })], 1)], 1)], 1) : _vm._e()], 1)], 1)], 1)], 1)], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };